import React, { useEffect } from "react";
import "./Preloader.css";

const Preloader = () => {
    setTimeout(function () {
        // document.querySelector("body").classList.add("loaded");
        document.getElementById("goldBar-preloader").classList.add("loaded");
        document.getElementById("preloader").removeAttribute("id");
        document.querySelector(".preloader-g").remove();
    }, 7000);

    return (
        // <div id="loader-wrapper">
        //     <div id="loader">
        //         <div class="img-fluid"></div>
        //         <img
        //             class=" mb-5"
        //             src={require("../../Assets/gbi.png")}
        //             alt="goldbar"
        //         />

        //         <span class="text1">Gold Bar</span>
        //         <span class="text2">International LTD</span>
        //     </div>
        //     <div class="loader-section section-left"></div>
        //     <div class="loader-section section-right"></div>
        // </div>
        <div id="preloader" class="preloader-g">
            <div id="goldBar-preloader" class="goldBar-preloader">
                <div class="animation-preloader">
                    {/* <div class="spinner"></div> */}
                    <img
                        src={require("../../Assets/chart.png")}
                        alt=""
                        style={{ transform: "scale(0.8)" }}
                    />
                    <div class="txt-loading">
                        <span data-text-preloader="G" class="letters-loading">
                            G
                        </span>
                        <span data-text-preloader="O" class="letters-loading">
                            O
                        </span>
                        <span data-text-preloader="L" class="letters-loading">
                            L
                        </span>
                        <span data-text-preloader="D" class="letters-loading">
                            D
                        </span>
                        <span data-text-preloader="B" class="letters-loading">
                            B
                        </span>
                        <span data-text-preloader="A" class="letters-loading">
                            A
                        </span>
                        <span data-text-preloader="R" class="letters-loading">
                            R
                        </span>
                    </div>
                    <div class="txt-loading">
                        <span data-text-preloader="I" class="letters-loading">
                            I
                        </span>
                        <span data-text-preloader="N" class="letters-loading">
                            N
                        </span>
                        <span data-text-preloader="T" class="letters-loading">
                            T
                        </span>
                        <span data-text-preloader="E" class="letters-loading">
                            E
                        </span>
                        <span data-text-preloader="R" class="letters-loading">
                            R
                        </span>
                        <span data-text-preloader="N" class="letters-loading">
                            N
                        </span>
                        <span data-text-preloader="A" class="letters-loading">
                            A
                        </span>
                        <span data-text-preloader="T" class="letters-loading">
                            T
                        </span>
                        <span data-text-preloader="I" class="letters-loading">
                            I
                        </span>
                        <span data-text-preloader="O" class="letters-loading">
                            O
                        </span>
                        <span data-text-preloader="N" class="letters-loading">
                            N
                        </span>
                        <span data-text-preloader="A" class="letters-loading">
                            A
                        </span>
                        <span data-text-preloader="L" class="letters-loading">
                            L
                        </span>
                    </div>
                </div>
                <div class="loader">
                    <div class="row">
                        <div class="col-3 loader-section section-left">
                            <div class="bg"></div>
                        </div>
                        <div class="col-3 loader-section section-left">
                            <div class="bg"></div>
                        </div>
                        <div class="col-3 loader-section section-right">
                            <div class="bg"></div>
                        </div>
                        <div class="col-3 loader-section section-right">
                            <div class="bg"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Preloader;
